(function (ws) {
    'use strict';
    ws.views.rfqListTable = ws.views.simpleTable.extend({

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'quote_activity',
        GTM_EVENT_ACTION: 'search_quote',

        /**
         * Events override
         */
        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'click .rfq-listing-checkbox-selectAll': 'toggleAllCheckboxes',
            'click .rfq-listing-checkbox': 'enableDownlodButton',
            'click .export-multiOrder': 'downloadMultipleOrder'
        }),

        /**
         * Initialize override
         */
        initialize: function () {
            this.controlColumn = 0;
            this.$table = $('#rfq-listing-table');
            this.paginateUrl = globals.path.api.westcon.rfqListingTablePaginateUrl;
            this.searchUrl = globals.path.api.westcon.rfqListingTableSearchUrl;
            this.rowTemplate = $('#rfq-listing-table-row');
            this.multiViewEnabled = this.$('#multiViewEnabled').val();
            this.enableRfqExport = this.$('#enableRfqExport').val();
            this.$selectAllCheckbox = this.$('.rfq-listing-checkbox-selectAll');

            if (this.multiViewEnabled == 'true') {
                this.$selectAllCheckbox.attr('checked', false);
                this.$('.rfq-listing-checkbox').prop('checked', false);
            }

            ws.views.simpleTable.prototype.initialize.call(this);

            //Making the select dropdowns without scroll and without search textbox
            $('.tbl-simple-filters select').select2({
                minimumResultsForSearch: Infinity,
                dropdownAutoWidth: true,
                dropdownCssClass: 'comp-order-table'
            });

            this.enableDownlodButton();
        },

        /**
         * Check select all checkbox and check/uncheck
         */
        checkSelectAllCheckbox () {
            const totalCheckboxes = this.$('.rfq-listing-checkbox:enabled').length;
            const selectedCheckboxes = $('.rfq-listing-checkbox:checked').length;
            if (selectedCheckboxes == 0) {
                this.$selectAllCheckbox.prop('checked', false);
            } else {
                this.$selectAllCheckbox.prop('checked', totalCheckboxes === selectedCheckboxes);
            }
        },

        /**
         * Change the state of all the checkboxes in the Order Listing table table.
         * @param {Object} ev
         */
        toggleAllCheckboxes: function (ev) {
            var $checkboxes = this.$('.rfq-listing-checkbox');
            var $checkboxAll = this.$('.rfq-listing-checkbox-selectAll');
            _.each($checkboxes, function(checkbox) {
                if (!$(checkbox).is(':disabled')) {
                    $(checkbox).prop('checked', $checkboxAll.is(':checked'));
                }
            });

            this.enableDownlodButton();
        },

        /**
         *  Enable the download button and disable Download Button
         */
        enableDownlodButton: function () {
            var $checkboxes = this.$('.rfq-listing-checkbox');
            var flag = 1;
            _.each($checkboxes, function(checkbox) {
                if (!$(checkbox).is(':disabled')) {
                    if ($(checkbox).is(':checked')) {
                        $('.export-multiOrder').attr('disabled', false);
                        flag = 0;
                    } else {
                        $('.rfq-listing-checkbox-selectAll').prop('checked', false);
                    }
                }
            });

            if (flag === 1) {
                $('.export-multiOrder').attr('disabled', true);
            }

            this.checkSelectAllCheckbox();
        },

        /**
         * Downloading the multiple orders excel functionality
         */
        downloadMultipleOrder: function () {
            globals.disableApp();
            let downloadText = $('.downloadAfterText').html();
            var $checkboxes = this.$('.rfq-listing-checkbox');
            var rfqsNumberList = [];
            _.each($checkboxes, function(checkbox) {
                if ($(checkbox).prop('checked') === true) {
                    rfqsNumberList.push($(checkbox).data('attr'));
                }
            });

            const CSRFToken = $('#CSRFToken').val();
            const urlExportOrderList = globals.path.api.westcon.exportRfqList + '?CSRFToken=' + CSRFToken;
            const data = {
                rfqsNumberList: rfqsNumberList
            };

            // DOWNLOADING EXCEL FILE FROM THE BLOB.
            const xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                var a;
                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    // Trick for making downloadable link
                    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
                        navigator.msSaveBlob(xhttp.response, `${downloadText}.xls`);
                    } else {
                        a = document.createElement('a');
                        a.href = window.URL.createObjectURL(xhttp.response);

                        // Give filename you wish to download
                        a.download = `${downloadText}.xls`;
                        a.style.display = 'none';
                        document.body.appendChild(a);
                        a.click();
                    }

                    globals.enableApp();
                }
            };

            xhttp.open('POST', urlExportOrderList);
            xhttp.setRequestHeader('Content-Type', 'application/json');
            xhttp.responseType = 'blob';
            xhttp.send(JSON.stringify(data));
        },

        /**
         * Call Search Filter API
         * Overriding from the parent view
         * @param {Object} request
         */
        searchFilterCall: function (request) {
            this.model.set(request);
            this.model.url = this.searchUrl;
            this.$table.dataTable().fnClearTable();
            this.$table.dataTable().fnDestroy();
            this.$table.DataTable().destroy();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();

            $.each(this.$tableHeaders, function (i, th) {
                $(th).removeClass('loaded');
            });

            // calling without arguments to hide pagination
            this.calculateShowing();
            this.calculatePagination();
            this.enableDelaySpinner();

            this.model.save().done(function (data) {
                this.$tableSpinner.hide();
                this.disabledDelaySpinner(this.showClearFilterButton);
                this.renderRows(data.data);
                this.calculateShowing(data.paginationData);
                this.calculatePagination(data.paginationData);
                this.$pagination.addClass('search');
                this.$clearFilterButton.toggle(this.showClearFilterButton);
                if (this.showClearFilterButton) {
                    this.$('.message-link').hide();
                }

                if (data.paginationData.numberOfPages > 1) {
                    $('.export-multiOrder').css('margin-right', '8%');
                } else {
                    $('.export-multiOrder').css('margin-right', '8%');
                }

                this.toggleApplySearchBtn(true);
            }.bind(this)).fail(function () {
                this.tableGenericError();
                this.disabledDelaySpinner();
            }.bind(this));
        },

        /**
         * Overiding the Render a table row from the parent
         * @param {Object} result
         */
        renderRows: function (result) {
            if ($('#enableRfqExport').val() == 'true') {
                this.$selectAllCheckbox.attr('checked', false);
                this.enableDownlodButton();
            }

            var options;
            var _this = this;
            _.each(result, function (row) {
                row.multiViewEnabled = _this.multiViewEnabled;
                row.enableRfqExport = _this.enableRfqExport;
                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };

                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        disableFutureDate: true
    });
})(westcon);
